import { useEffect, useState } from 'react';
import { Save } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { DiscordCategoryPicker } from '@/components/discord/DiscordPickers';
import { ApiError } from '@/lib/api';
import { useServerConfig, useUpdateServerConfig } from '@/lib/queries';
import { useCan } from '@/lib/use-can';

export function ServerPage() {
  const can = useCan();
  const cfg = useServerConfig();
  const update = useUpdateServerConfig();
  const [name, setName] = useState('');
  const [archiveCategoryId, setArchiveCategoryId] = useState('');

  useEffect(() => {
    if (cfg.data) {
      setName(cfg.data.name ?? '');
      setArchiveCategoryId(cfg.data.archiveCategoryId ?? '');
    }
  }, [cfg.data]);

  if (!can('settings.server')) {
    return <p className="text-muted-foreground">You don't have access to this page.</p>;
  }

  async function handleSave() {
    try {
      await update.mutateAsync({
        name: name || null,
        archiveCategoryId: archiveCategoryId || null,
      });
      toast.success('Saved');
    } catch (err) {
      toast.error(err instanceof ApiError ? err.message : 'Error');
    }
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Server settings</h1>
        <p className="text-muted-foreground">Per-guild configuration</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>General</CardTitle>
          <CardDescription>Used in some embeds and the deploy banner</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="name">Server display name (optional)</Label>
            <Input id="name" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="space-y-2">
            <Label>Archive category</Label>
            <DiscordCategoryPicker value={archiveCategoryId} onValueChange={setArchiveCategoryId} />
          </div>
          <Button onClick={handleSave} disabled={update.isPending}>
            <Save className="mr-2 h-4 w-4" />
            Save
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
